import { Layers, Pause, Pencil, Play, Ticket } from 'lucide-react';
import { formatCurrency } from '../../data/mockData';
import styles from './Promotions.module.css';

const STATUS_CLASS = { ACTIVE: 'statusActive', PAUSED: 'statusPaused', EXPIRED: 'statusExpired', INACTIVE: 'statusInactive' };

function formatShortDate(iso) {
  return new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

export default function CouponCard({ coupon, onEdit, onToggle, toggling }) {
  const validity = coupon.startsAt && coupon.endsAt
    ? `${formatShortDate(coupon.startsAt)} – ${formatShortDate(coupon.endsAt)}`
    : coupon.endsAt ? `Until ${formatShortDate(coupon.endsAt)}` : 'No expiry';

  const totalLimit = coupon.maxRedemptionsGlobal ? `${coupon.maxRedemptionsGlobal} total` : 'Unlimited total';
  const perUserLimit = coupon.maxRedemptionsPerUser ? `${coupon.maxRedemptionsPerUser} / customer` : 'unlimited / customer';

  return (
    <div className={styles.coupon}>
      <div className={styles.couponHead}>
        <span className={styles.couponIcon}><Ticket size={16} /></span>
        <div className={styles.couponHeadText}>
          <p className={styles.couponCode}>{coupon.code}</p>
          <p className={styles.couponValue}>
            {coupon.discountType === 'PERCENT' ? `${coupon.discountValue}% off` : `${formatCurrency(coupon.discountValue)} off`}
            {coupon.minOrderAmount > 0 && ` · min ${formatCurrency(coupon.minOrderAmount)}`}
          </p>
        </div>
        <span className={`${styles.statusChip} ${styles[STATUS_CLASS[coupon.status]] || ''}`}>{coupon.status}</span>
      </div>

      <div className={styles.perforation} />

      <div className={styles.couponBody}>
        <div className={styles.usageRow}>
          <span>{totalLimit} · {perUserLimit}</span>
          <span>{validity}</span>
        </div>

        {coupon.stackable && (
          <span className={styles.stackableBadge}><Layers size={11} /> Stackable</span>
        )}

        <div className={styles.couponActions}>
          <button className={styles.couponBtn} onClick={() => onEdit(coupon)}>
            <Pencil size={13} /> Edit
          </button>
          {(coupon.status === 'ACTIVE' || coupon.status === 'PAUSED') && (
            <button className={styles.couponBtn} onClick={() => onToggle(coupon)} disabled={toggling}>
              {toggling
                ? '…'
                : coupon.status === 'ACTIVE' ? <><Pause size={13} /> Pause</> : <><Play size={13} /> Resume</>}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
